import React from "react";
// import HallFameContent from "../FunctionalComponents/HallFame/HallFameContent";
import HallFameCommingsoon from "../FunctionalComponents/HallFame/HallFameCommingsoon";

function HallFame() {
  return (
    <>
      {/* <HallFameContent /> */}
      <HallFameCommingsoon />
    </>
  );
}

export default HallFame;
